import * as React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { CommonTs } from '../../locales';

interface IProps {
  messages: CommonTs;
  lang: string;
}

const FooterStyle = ({ messages, lang }: IProps) => {

  let langUrl = `/${lang}`;

  const { pathname } = window.location;

  if (window.location && pathname.indexOf(lang) < 0) {
    langUrl = '';
  }

  return (
    <Footer>
      <Wrap>
        <Sitemap>
          {
            messages.sitemap.map((item, i) => 
              <NavArea key={i}>
                <h2>{item.cur}</h2>
                <ul>
                  {
                    item.sub.map((list, j) =>
                      <li key={j}><Link to={`${langUrl}${list.href}`} target={list.target && `${list.target}`}>{list.cur}</Link></li>
                    )
                  }
                </ul>
              </NavArea>)
          }
        </Sitemap>
        <SnsArea>
          <h2>{messages.snsNav.cur}</h2>
          <ul>
            {
              messages.snsNav.list.map((item, i) =>
                <li key={i}><a href={item.href} id={item.id} target='_blank'>{item.cur}</a></li>
              )
            }
          </ul>
        </SnsArea>
        <Address dangerouslySetInnerHTML={ {__html: messages.address} }/>
        <Copyright dangerouslySetInnerHTML={ {__html: messages.copyright} }/>
      </Wrap>
    </Footer>
  )
}

export default FooterStyle;


const Footer = styled.footer`
  position: relative;
  color: #b6b6b6;
  background: #202020;
`;

const Wrap = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 55px 20px 0;
  width: 1240px;
`;

const SecTit = css`
  color: #9f8a6d;
  font-weight: bold;
`;

const Sitemap = styled.div`
  display: flex;
  margin-bottom: 30px;
  min-height: 140px;
  float: right;
`;

const NavArea = styled.div`
  margin-left: 45px;

  & > h2 {
    position: relative;
    padding-bottom: 12px;
    ${SecTit}

    &::after {
      content:"";
      position: absolute;
      bottom: 0; left: 0;
      width: 18px; height: 1px;
      background-color: #4d4d4d;
    }
  }
  
  & > ul {
    margin-top: 10px;
    line-height: 1.67;
    font-size: 12px;

    & a {
      display: block;
    }
  }
`;

const SnsArea = styled.div`
  position: absolute;
  top: 118px; left: 20px;
  z-index: 1;

  & h2 {
    display: inline-block;
    padding-right: 12px;
    background: #202020;
    ${SecTit}
  }

  & ul {
    display: flex;
    margin-top: 20px;
    line-height: 1.8;
    font-size: 12px;

    & li {
      margin-left: 30px;
      &:first-child {
        margin-left: 0;
      }
    }

    & li > a {
      display: block;
      position: relative;
      padding: 0 0 0 34px;

      &:before {
        content:"";
        position: absolute;
        top: 0; left: 0;
        width: 24px; height: 22px;
      }

      &#kakao:before {
        background: url(${require('../../assets/common/kakao@2x.png')}) center center no-repeat;
        background-size: 24px auto;
      }
      &#facebook:before {
        background: url(${require('../../assets/common/facebook@2x.png')}) center center no-repeat;
        background-size: 9px auto;
      }
      &#twitter:before {
        background: url(${require('../../assets/common/twitter@2x.png')}) center center no-repeat;
        background-size: 19px auto;
      }
      &#telegram:before {
        background: url(${require('../../assets/common/telegram@2x.png')}) center center no-repeat;
        background-size: 19px auto;
      }
    }
  }
`;


const Address = styled.address`
  position: absolute;
  top: 55px; left: 20px;
  padding-bottom: 30px;
  height: 71px;
  line-height: 1.6;
  border-bottom: 1px solid #333;
`;

const Copyright = styled.p`
  padding: 20px 0 65px;
  line-height: 1.83;
  font-size: 12px;
  border-top: 1px solid #333;
  background: url(${require('../../assets/common/logo-gray@2x.png')}) 0 30px no-repeat;
  background-size: 164px;
  text-align: right;
  clear: both;
`;


// WEBPACK FOOTER //
// ./src/styles/layout/footer.tsx